import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { UserService, PatientService, User, FormSessionCanDeactivate } from '../../shared';
import { environment } from '../../shared/config/app-config';
// import { DataTableDirective } from 'angular-datatables';

@Component({
  selector: 'app-hospitalmetrics',
  templateUrl: './hospitalmetrics.component.html',
  styleUrls: ['./hospitalmetrics.component.css']
})
export class HospitalmetricsComponent extends FormSessionCanDeactivate {
  public temp_repvar: boolean = false;
  public reportvar: any;
  public bodypart: any;
  public enableTable: boolean = false;
  public reportList = []
  public hospitalId: any = 0;
  tempArray = [];
  public servId: any = 0;
  // @ViewChild(DataTableDirective) datatableElement: DataTableDirective;
  data: any;
  public tableFilter = '';
  public stagefilter = '';
  public tableType = 'Select Body Location';
  public apiurl: any = environment.api_url;
  public datatable: any;
  dtOptions: any = {};
  hospital: any;
  public imageURL: string = environment.cloudeImageURL;
  public currentUser: User;

  public upperBodypartOption = [
    {
      'value': '7',
      'name': 'Neck'
    },
    {
      'value': '6',
      'name': 'Back'
    },
    {
      'value': '15',
      'name': 'Shoulder - Left'
    },
    {
      'value': '16',
      'name': 'Shoulder - Right'
    },
    {
      'value': '19',
      'name': 'Elbow - Left'
    },
    {
      'value': '20',
      'name': 'Elbow - Right'
    },
    {
      'value': '25',
      'name': 'Hand - Left'
    },
    {
      'value': '26',
      'name': 'Hand - Right'
    },
    {
      'value': '13',
      'name': 'Wrist - Left'
    },
    {
      'value': '14',
      'name': 'Wrist - Right'
    },
    {
      'value': '21',
      'name': 'Arm - Left'
    },
    {
      'value': '22',
      'name': 'Arm - Right'
    },
    {
      'value': '23',
      'name': 'Fore Arm - Left'
    },
    {
      'value': '24',
      'name': 'Fore Arm - Right'
    }
  ]
  public lowerBodypartOption = [
    {
      'value': '1',
      'name': 'Total Hip - Left'
    },
    {
      'value': '2',
      'name': 'Total Hip - Right'
    },
    {
      'value': '1,2',
      'name': 'Total Hip - Bilateral'
    },
    {
      'value': '3',
      'name': 'Total Knee - Left'
    },
    {
      'value': '4',
      'name': 'Total Knee - Right'
    },
    {
      'value': '3,4',
      'name': 'Total Knee - Bilateral'
    },
    {
      'value': '33',
      'name': 'Partial Knee - Left'
    },
    {
      'value': '34',
      'name': 'Partial Knee - Right'
    },
    {
      'value': '33,34',
      'name': 'Partial Knee - Bilateral'
    },
    {
      'value': '11',
      'name': 'Knee Sports - Left'
    },
    {
      'value': '12',
      'name': 'Knee Sports - Right'
    },
    {
      'value': '11,12',
      'name': 'Knee Sports - Bilateral'
    },
    {
      'value': '27',
      'name': 'Foot - Left'
    },
    {
      'value': '28',
      'name': 'Foot - Right'
    },
    {
      'value': '29',
      'name': 'Ankle - Left'
    },
    {
      'value': '30',
      'name': 'Ankle - Right'
    }
  ]
  public otherBodypartOption = [
    {
      'value': '52',
      'name': 'General Health'
    },
    {
      'value': '5',
      'name': 'Satisfaction'
    },
    {
      'value': '54',
      'name': 'Pain'
    }
  ]

  constructor(private patientservice: PatientService,
    private userService: UserService, ) {
    super();
  }

  ngOnInit() {
    this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
      }
    )

    if (this.currentUser.item.hostModel == "CLOUD")
      this.imageURL = environment.cloudeImageURL;
    else
      this.imageURL = environment.vmImageURL;

    let self = this;

    self.dtOptions = {
      // Configure the pagelength
      pagelength: 10,
      lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
      dom: 'Blfrtip',
      buttons: [
        {
          extend: 'excelHtml5',
          text: 'Download Excel',
          className: 'datatablebuttons btn btn-chnag buttons-pdf buttons-html5',
          title: this.getTitle()
        },
        {
          extend: 'pdfHtml5',
          orientation: 'landscape',
          text: 'Download PDF',
          className: 'datatablebuttons btn btn-chnag buttons-pdf buttons-html5',
          title: this.getTitle()
        },

      ]
      // initComplete:self.getFilterOption
    };
    self.getBasicDetails();
    self.getpatiemtsReportList();
    self.datatableConfig()
  }

  getFilterOption() {
    let dApi: any;
    dApi.columns().every(function () {
    })
  }

  getBasicDetails() {
    this.patientservice
      .getpatients_report_landing()
      .subscribe(
        data => {
          this.temp_repvar = true;
          this.hospital = data;
        }

      );
  }
  getTitle() {
    return `Reports List`
  }

  getReportListByStage() {
    // this.datatableElement.dtInstance.then((dtInstance) => {
    //   dtInstance.draw();
    // });
  }

  getpatiemtsReportList() {
    let self = this;
    self.enableTable = false;
    self.patientservice.getpatients_report_list()
      .subscribe(data => {
        self.enableTable = true;
        self.reportList = data
      })
  }

  getReportListByHospital() {
    let self = this;
    self.enableTable = false
    //  self.reportList = []
    self.patientservice.filterReports(self.hospitalId, self.servId)
      // self.patientservice.getpatients_report_list()
      .subscribe(res => {
        self.enableTable = true;
        self.reportList = res
      })
  }

  upperbody: any = 'neck,back,shoulder,elbow,hand,wrist'.split(',');
  lowerbody: any = 'Total Hip - Left,Total Hip - Right,Total Hip - Bilateral,Total Knee - Left,Total Knee - Right,Total Knee - Bilateral,Partial Knee - Left,Partial Knee - Right,Partial Knee - Bilateral,Knee Sports - Left,Knee Sports - Right,Knee Sports - Bilateral,Foot & Ankle'.split(',');
  other: any = 'General Health,Satisfaction,Pain'.split(',');
  getbodylist(type: string) {
    let self = this;
    self.tableFilter = '';
    //////console.log(type);
    this.data = {
      'bodylocation': type
    }
    switch (type) {
      case "upperbody":

        this.bodypart = this.upperBodypartOption;
        break;
      case "lowerbody":
        this.bodypart = this.lowerBodypartOption;
        break;
      case "other":
        this.bodypart = this.otherBodypartOption;
        break;
    }
  }

  datatableConfig() {
    $.fn['dataTable'].ext.search.push((settings, data, dataIndex) => {
      const rowdata: string = data[6] || '';
      if (this.stagefilter != '') {
        if (rowdata == this.stagefilter)
          return true
      }
      if (this.stagefilter == '') {
        return true;
      }
      return false;
    });

  }


  ngOnDestroy() {
    this.stagefilter = ''
  }



}
